// @ts-nocheck
import { ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ReactNode, MouseEventHandler } from 'react';

type MobileListItemProps = {
  icon?: ReactNode;
  iconBg?: string; // tailwind bg class (e.g. "bg-primary/15 text-primary")
  title: ReactNode;
  subtitle?: ReactNode;
  meta?: ReactNode; // texto/valor à direita (abaixo do chevron)
  badges?: ReactNode; // linha extra de badges/tags
  onClick?: MouseEventHandler<HTMLDivElement>;
  chevron?: boolean;
  className?: string;
};

export const MobileListItem = ({
  icon,
  iconBg = 'bg-primary/15 text-primary',
  title,
  subtitle,
  meta,
  badges,
  onClick,
  chevron = true,
  className,
}: MobileListItemProps) => {
  const clickable = !!onClick;
  return (
    <div
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onClick={onClick}
      onKeyDown={(e) => {
        if (!clickable) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.(e as any);
        }
      }}
      className={cn(
        'flex items-start gap-3 px-4 py-3 bg-card transition-colors active:bg-muted/70 select-none',
        clickable && 'cursor-pointer',
        className,
      )}
    >
      {icon && (
        <div
          className={cn(
            'h-10 w-10 rounded-xl flex items-center justify-center shrink-0 shadow-[0_6px_16px_-10px_rgba(0,0,0,0.4)]',
            iconBg,
          )}
        >
          {icon}
        </div>
      )}

      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <p className="font-semibold text-[15px] leading-tight truncate">
            {title}
          </p>
          {meta && (
            <span className="text-xs text-muted-foreground shrink-0 tabular-nums">
              {meta}
            </span>
          )}
        </div>
        {subtitle && (
          <p className="mt-0.5 text-[13px] text-muted-foreground line-clamp-2">
            {subtitle}
          </p>
        )}
        {badges && <div className="mt-1.5 flex flex-wrap gap-1.5">{badges}</div>}
      </div>

      {chevron && clickable && (
        <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0 mt-1" />
      )}
    </div>
  );
};
